import { render, staticRenderFns } from "./UsuarioResetarSenha.vue?vue&type=template&id=5e686c57&"
import script from "./UsuarioResetarSenha.vue?vue&type=script&lang=js&"
export * from "./UsuarioResetarSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports